import { memory } from './index';
import { POS_DEVICE_ID } from '../App.constants';

const MAX_LENGTH = 64;

let cached: string | null = null;

export const getPosDeviceId = (): string => {
  if (cached)
    return cached;

  cached = readStored() ?? persistNew();

  return cached;
};

const readStored = (): string | null => {
  try {
    const stored = memory.get<string>(POS_DEVICE_ID);

    return typeof stored === 'string' && stored.length > 0 && stored.length <= MAX_LENGTH
      ? stored
      : null;
  } catch {
    return null;
  }
};

const persistNew = (): string => {
  const id = createId();

  try {
    memory.set(POS_DEVICE_ID, id);
  } catch {
    // Keep going with a page-lifetime id rather than failing the request.
  }

  return id;
};

const createId = (): string =>
  globalThis.crypto?.randomUUID?.()
  ?? `${ Date.now().toString(36) }-${ Math.random().toString(36).slice(2, 12) }`;
